export enum AccountStatusTypes {
  Open = 'Open',
  Closed = 'Closed',
  Deceased = 'Deceased',
  NonDeliverable = 'Non-Deliverable'
}

export type Color =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warn'
  | 'info'
  | 'reward'
  | 'white'
  | 'first-class'
  | 'delta-one'
  | 'comfort-plus'
  | 'main-cabin'
  | 'none';

export type HexColor = `#${string}`;

export type PositionType =
  | 'bottom'
  | 'left'
  | 'left-start'
  | 'right'
  | 'top'
  | 'top-right'
  | 'top-left'
  | 'bottom-left'
  | 'bottom-right'
  | 'center'
  | 'outside'
  | 'none';
